import {
    grupoUsuario_admins,
    grupoUsuario_administrador,
    grupoUsuario_analistafinanceiro,
    grupoUsuario_contabilidade,
    grupoUsuario_analistaprojeto,
    grupoUsuario_coordenador,
    grupoUsuario_analistacompra,
    grupoUsuario_gestores,
    grupoUsuario_ordenadordespesa,
    grupoUsuario_recursoshumanos,
    grupoUsuario_pessoal,
    grupoUsuario_bolsistasprojetos,
    grupoUsuario_analistacrci,
    grupoUsuario_subcoordenador,
    grupoUsuario_visualizadorcompras,
    grupoUsuario_funcionario,
} from '@/commons/utils';

export const BASE_GROUPS = {
    ADMIN: [grupoUsuario_admins], // Administrador Global
    ADMINISTRADOR: [grupoUsuario_administrador], // Administrador de TI
    FINANCEIRO: [grupoUsuario_analistafinanceiro], // Financeiro
    CONTABILIDADE: [grupoUsuario_contabilidade], // Contabilidade
    PROJETO: [grupoUsuario_analistaprojeto], // Projeto
    COMPRAS: [grupoUsuario_analistacompra], // Compras
    GESTAO: [grupoUsuario_gestores], // Gestão
    COORDENADOR: [grupoUsuario_coordenador, grupoUsuario_subcoordenador], // Coordenador
    FUNCIONARIO: [grupoUsuario_funcionario], // Funcionário
    ORDENADOR: [grupoUsuario_ordenadordespesa], // Ordenador de Despesa
    RH: [grupoUsuario_recursoshumanos], // Recursos Humanos
    PESSOAL: [grupoUsuario_pessoal], // Pessoal
    CRCI: [grupoUsuario_analistacrci], // Analista CRCI
    BOLSISTAPROJETO: [grupoUsuario_bolsistasprojetos], // Bolsistas de Projetos
    VISUALIZADOR_COMPRAS: [grupoUsuario_visualizadorcompras], // Visualizador de Compras
}

export const composePermissions = (...groupKeys) => {
    return [...BASE_GROUPS.ADMIN, ...groupKeys.flatMap(key => BASE_GROUPS[key] || [])]
}

export const COMMON_PERMISSIONS = {
    ADMIN_ONLY: composePermissions('ADMIN'),
    ADMINISTRADORES: composePermissions('ADMINISTRADOR', 'ADMIN'),
    TODOS: composePermissions('ADMINISTRADOR', 'FINANCEIRO', 'CONTABILIDADE', 'PROJETO', 'COMPRAS', 'GESTAO', 'ORDENADOR', 'RH', 'PESSOAL', 'CRCI', 'BOLSISTAPROJETO', 'VISUALIZADOR_COMPRAS'),
    COMPRAS: composePermissions('ADMINISTRADOR', 'COMPRAS'),
    OPERACOES_FINANCEIRAS: composePermissions('FINANCEIRO', 'GESTAO', 'PROJETO', 'CONTABILIDADE', 'COORDENADOR'),
    EQUIPE_GESTAO_PROJETOS: composePermissions('PROJETO', 'ORDENADOR', 'PESSOAL', 'COMPRAS', 'GESTAO', 'COORDENADOR'),
    EQUIPE_GESTAO_ORDENADOR: composePermissions('ORDENADOR'),

    RH_ONLY: composePermissions('RH'),
    EQUIPE_RH_ORDENADOR: composePermissions('RH', 'ORDENADOR', 'FINANCEIRO', 'PROJETO'),
    PROJETO_ONLY: composePermissions('PROJETO'),
    COMPRAS_COMPLETO: composePermissions('COMPRAS', 'GESTAO'),
    COMPRAS_VISUALIZAR: composePermissions('COMPRAS', 'GESTAO', 'PROJETO', 'RH'),
}